import request from '../../config/axiosConfig';
import { CREATE_PARTNER, DELETE_PARTNER, GET_LIST_PARTNERS, GET_PARTNER_INFO, UPDATE_PARTNER } from '../../constants/apiEndPoint';

export const getListPartnersRequest = async (data) => {
  const result = await request({
    url: GET_LIST_PARTNERS,
    method: 'POST',
    data,
  });
  return result?.data.data;
};

export const getPartnerInfoRequest = async (data) => {
  const result = await request({
    url: GET_PARTNER_INFO,
    method: 'POST',
    data,
  });
  return result?.data.data;
};

export const createPartnerRequest = async (data) => {
  const result = await request({
    url: CREATE_PARTNER,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const updatePartnerRequest = async (data) => {
  const result = await request({
    url: UPDATE_PARTNER,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const deletePartnerRequest = async (data) => {
  const result = await request({
    url: DELETE_PARTNER,
    method: 'POST',
    data,
  });
  return result?.data;
};
